<script setup lang="ts">
import { computed } from 'vue'

import type { SubParticipant } from '@collector/sportsapi-types'

import type { LineupConfig } from '../../../../interfaces/LineupConfig'
import type { LineupModel } from '../../../../interfaces/LineupModel'
import AddToPositionButtonGroup from '../../../common/AddToPositionButtonGroup.vue'
import PlayerName from '../PlayerName.vue'
import { canAddParticipantSubTypeToPosition } from './utils'

type Props = {
  config: LineupConfig
  lineup: LineupModel
  player: SubParticipant
}
const props = defineProps<Props>()

type Emits = {
  add: [positionKey: PropertyKey, player: SubParticipant]
}
const emit = defineEmits<Emits>()

// computed
const subType = computed(() => props.player.details?.subtype || null)
</script>

<template>
  <div
    class="bg-neutral-light-10 hover:bg-neutral-light-5 flex flex-wrap items-center gap-2 rounded-md p-1 transition-colors @md:flex-nowrap"
    data-testid="lineups-season-squad-row"
  >
    <div class="flex min-h-8 grow items-center gap-2">
      <div class="w-8 min-w-0 shrink-0 text-right font-bold">
        {{ player.shirt_nr }}
      </div>
      <div class="min-w-0">
        <PlayerName
          :player
          :highlightMissingId="config.display.highlightMissingId"
        />
      </div>
    </div>
    <div class="flex min-w-full shrink-0 gap-2 @md:min-w-0">
      <AddToPositionButtonGroup
        :config
        :lineup
        :subType
        :shirtNr="player.short_name"
        type="squad"
        :shouldRenderButton="canAddParticipantSubTypeToPosition"
        @add="emit('add', $event, player)"
      />
    </div>
  </div>
</template>

<style scoped></style>
